export const DT_SPECIAL_WIDGETS = [
  { type: 'dt-radial-gauge',      label: 'Radial Gauge',        icon: '📊', description: 'Contact wear per pole (R/Y/B)' },
  { type: 'dt-simulation-gauge',  label: 'Simulation Gauge',    icon: '🌡️', description: 'ECharts gauge + simulated temperature' },
  { type: 'dt-temperature-grid',  label: 'Temperature Grid',    icon: '🟥', description: '2×3 temperature sensor readings' },
  { type: 'dt-temperature-trend', label: 'Temperature Trend',   icon: '📈', description: 'Temperature trend line chart' },
  { type: 'dt-metering-bars',     label: 'Metering Bars',       icon: '⚡', description: 'Current and voltage bar charts' },
  { type: 'dt-breaker-data',      label: 'Breaker Data',        icon: '🔌', description: 'Contact wear + fault counters + operations' },
  { type: 'dt-vfd-status',        label: 'VFD Status',          icon: '🔄', description: 'VFD status indicator + parameters' },
  { type: 'dt-status-indicators', label: 'Status Indicators',   icon: '🟢', description: 'Thermal/Trip/Status pill indicators' },
  { type: 'dt-voltage-table',     label: 'Voltage Table',       icon: '⚡', description: 'Key-value voltage readings' },
  { type: 'dt-current-table',     label: 'Current Table',       icon: '〰️', description: 'Key-value current readings' },
  { type: 'dt-general-info',      label: 'General Info',        icon: 'ℹ️', description: 'Iframe, Irated, Poles display' },
];

export const GENERAL_WIDGET_GROUPS = {
  Charts: [
    { type: 'Line Chart',     label: 'Line Chart',     icon: '📈' },
    { type: 'Bar Chart',      label: 'Bar Chart',      icon: '📊' },
    { type: 'Area Chart',     label: 'Area Chart',     icon: '📉' },
    { type: 'Pie Chart',      label: 'Pie Chart',      icon: '🥧' },
    { type: 'Radar Chart',    label: 'Radar Chart',    icon: '🕸️' },
    { type: 'Doughnut Chart', label: 'Doughnut Chart', icon: '🍩' },
    { type: 'Scatter Chart',  label: 'Scatter Chart',  icon: '✦' },
  ],
  Gauges: [
    { type: 'Circular Gauge',     label: 'Circular Gauge',     icon: '🔵' },
    { type: 'Semi Circular Gauge',label: 'Semi Circular Gauge',icon: '⬛' },
    { type: 'Linear Gauge',       label: 'Linear Gauge',       icon: '📏' },
    { type: 'Speed Gauge',        label: 'Speed Gauge',        icon: '🏎️' },
    { type: 'Temperature Gauge',  label: 'Temperature Gauge',  icon: '🌡️' },
  ],
  Cards: [
    { type: 'Single Value', label: 'Single Value', icon: '🔢' },
    { type: 'Multi Value',  label: 'Multi Value',  icon: '🔢' },
    { type: 'Status Card',  label: 'Status Card',  icon: '🟢' },
  ],
  Tables: [
    { type: 'Timeseries Table', label: 'Timeseries Table', icon: '📋' },
  ],
  Controls: [
    { type: 'Status',    label: 'Status',    icon: '🟢' },
    { type: 'Switch',    label: 'Switch',    icon: '🔘' },
    { type: 'Set Value', label: 'Set Value', icon: '✏️' },
  ],
};

export const CHART_TYPES = new Set(['Line Chart', 'Bar Chart', 'Area Chart', 'Pie Chart', 'Radar Chart', 'Doughnut Chart', 'Scatter Chart']);
export const GAUGE_TYPES = new Set(['Circular Gauge', 'Semi Circular Gauge', 'Linear Gauge', 'Speed Gauge', 'Temperature Gauge']);
export const DT_SPECIAL_TYPES = new Set(DT_SPECIAL_WIDGETS.map((w) => w.type));

export function classifyWidget(type) {
  if (DT_SPECIAL_TYPES.has(type)) return 'dt-special';
  if (CHART_TYPES.has(type)) return 'chart';
  if (GAUGE_TYPES.has(type)) return 'gauge';
  return 'general';
}

// ── Slot schemas for dt-special widgets ─────────────────────────────────────
// Each slot has: key (internal), label (display name), unit (hint), required
export const DT_WIDGET_SLOTS = {
  'dt-voltage-table': [
    { key: 'L1',      label: 'L1 Voltage (V)',       unit: 'V' },
    { key: 'L2',      label: 'L2 Voltage (V)',       unit: 'V' },
    { key: 'L3',      label: 'L3 Voltage (V)',       unit: 'V' },
    { key: 'Average', label: 'Average Voltage (V)',  unit: 'V' },
  ],
  'dt-current-table': [
    { key: 'RMS_R',   label: 'RMS R Current (A)',       unit: 'A' },
    { key: 'RMS_Y',   label: 'RMS Y Current (A)',       unit: 'A' },
    { key: 'RMS_B',   label: 'RMS B Current (A)',       unit: 'A' },
    { key: 'THD_R',   label: 'THD R Phase Current (%)', unit: '%' },
    { key: 'THD_Y',   label: 'THD Y Phase Current (%)', unit: '%' },
    { key: 'THD_B',   label: 'THD B Phase Current (%)', unit: '%' },
  ],
  'dt-radial-gauge': [
    { key: 'contactWearR', label: 'Contact Wear R (%)', unit: '%' },
    { key: 'contactWearY', label: 'Contact Wear Y (%)', unit: '%' },
    { key: 'contactWearB', label: 'Contact Wear B (%)', unit: '%' },
  ],
  'dt-vfd-status': [
    { key: 'vfdStatus',    label: 'VFD Status',          unit: '' },
    { key: 'motorVoltage', label: 'Motor Voltage (V)',    unit: 'V' },
    { key: 'dcLinkVoltage',label: 'DC Link Voltage (V)',  unit: 'V' },
    { key: 'current',      label: 'Current (A)',          unit: 'A' },
    { key: 'power',        label: 'Power (kW)',           unit: 'kW' },
    { key: 'frequency',    label: 'Frequency (Hz)',       unit: 'Hz' },
    { key: 'powerFactor',  label: 'Power Factor',         unit: '' },
  ],
  'dt-status-indicators': [
    { key: 'thermalStatus', label: 'Thermal Status',    unit: '' },
    { key: 'tripInfo',      label: 'Trip Information',  unit: '' },
    { key: 'status',        label: 'Status (ON/OFF)',   unit: '' },
    { key: 'L1',            label: 'L1 Voltage (V)',    unit: 'V' },
    { key: 'L2',            label: 'L2 Voltage (V)',    unit: 'V' },
    { key: 'L3',            label: 'L3 Voltage (V)',    unit: 'V' },
    { key: 'Average',       label: 'Average Voltage (V)', unit: 'V' },
    { key: 'RMS_R',         label: 'RMS R Current (A)', unit: 'A' },
    { key: 'RMS_Y',         label: 'RMS Y Current (A)', unit: 'A' },
    { key: 'RMS_B',         label: 'RMS B Current (A)', unit: 'A' },
    { key: 'THD_R',         label: 'THD R Phase Current (%)', unit: '%' },
    { key: 'THD_Y',         label: 'THD Y Phase Current (%)', unit: '%' },
    { key: 'THD_B',         label: 'THD B Phase Current (%)', unit: '%' },
  ],
  'dt-metering-bars': [
    { key: 'ir',  label: 'Current R (A)',   unit: 'A' },
    { key: 'iy',  label: 'Current Y (A)',   unit: 'A' },
    { key: 'ib',  label: 'Current B (A)',   unit: 'A' },
    { key: 'in',  label: 'Current N (A)',   unit: 'A' },
    { key: 'vry', label: 'Voltage RY (V)',  unit: 'V' },
    { key: 'vyb', label: 'Voltage YB (V)',  unit: 'V' },
    { key: 'vbr', label: 'Voltage BR (V)',  unit: 'V' },
  ],
  'dt-temperature-trend': [
    { key: 'temp1', label: 'Temperature 1 (°C)', unit: '°C' },
    { key: 'temp2', label: 'Temperature 2 (°C)', unit: '°C' },
    { key: 'temp3', label: 'Temperature 3 (°C)', unit: '°C' },
  ],
  'dt-temperature-grid': [
    { key: 'hbbR', label: 'HBB R (°C)', unit: '°C' },
    { key: 'hbbY', label: 'HBB Y (°C)', unit: '°C' },
    { key: 'hbbB', label: 'HBB B (°C)', unit: '°C' },
    { key: 'ctR',  label: 'CT R (°C)',  unit: '°C' },
    { key: 'ctY',  label: 'CT Y (°C)',  unit: '°C' },
    { key: 'ctB',  label: 'CT B (°C)',  unit: '°C' },
  ],
  'dt-breaker-data': [
    { key: 'contactWearR',  label: 'Contact Wear R (%)',  unit: '%' },
    { key: 'contactWearY',  label: 'Contact Wear Y (%)',  unit: '%' },
    { key: 'contactWearB',  label: 'Contact Wear B (%)',  unit: '%' },
    { key: 'faultCounterL', label: 'Fault Counter L',     unit: '' },
    { key: 'faultCounterI', label: 'Fault Counter I',     unit: '' },
    { key: 'faultCounterG', label: 'Fault Counter G',     unit: '' },
    { key: 'faultCounterS', label: 'Fault Counter ETU',   unit: '' },
    { key: 'onOperation',   label: 'On Operations',       unit: '' },
    { key: 'offOperation',  label: 'Off Operations',      unit: '' },
  ],
  'dt-general-info': [
    { key: 'iframe', label: 'Iframe',  unit: 'A' },
    { key: 'irated', label: 'Irated',  unit: 'A' },
    { key: 'poles',  label: 'Poles',   unit: '' },
  ],
};

export function getDTWidgetSlots(type) {
  return DT_WIDGET_SLOTS[type] || null;
}

/**
 * Builds a slot-value map from tagprops + live data array.
 * Returns { [slotKey]: { value, alias, unit, tagId } }
 * Works for both slot-based (slotKey present) and legacy (no slotKey) tagprops.
 */
export function resolveSlotValues(tagprops, liveData) {
  const dataMap = {};
  (liveData || []).forEach((d) => { dataMap[String(d.TagId)] = d; });
  const result = {};
  (tagprops || []).forEach((tp) => {
    const key = tp.slotKey || tp.alias || tp.tagId;
    const live = dataMap[String(tp.tagId)];
    result[key] = {
      value: live?.value ?? null,
      alias: tp.alias || tp.slotKey || String(tp.tagId),
      unit: tp.unit || '',
      tagId: tp.tagId,
    };
  });
  return result;
}

export function getMaxDatapoints(type) {
  if (['Circular Gauge', 'Semi Circular Gauge', 'Linear Gauge', 'Speed Gauge', 'Temperature Gauge', 'Single Value'].includes(type)) return 1;
  if (type === 'Multi Value') return 5;
  if (['Pie Chart', 'Doughnut Chart', 'Radar Chart'].includes(type)) return 8;
  if (type === 'Timeseries Table') return 20;
  if (CHART_TYPES.has(type)) return 10;
  // dt-special slot-based widgets
  const slots = DT_WIDGET_SLOTS[type];
  if (slots) return slots.length;
  return 1;
}

/**
 * Default grid height (in rows) per widget type.
 * ROW_HEIGHT = 80px, MARGIN = 8px  →  effective px = h * 80 + (h-1) * 8
 *   h=4  →  ~344px   (small cards / single value)
 *   h=5  →  ~432px   (gauges, status, tables)
 *   h=6  →  ~520px   (charts, trend lines)
 *   h=7  →  ~608px   (complex multi-section widgets)
 */
const DEFAULT_WIDGET_H = {
  // General — cards
  'Single Value':       4,
  'Multi Value':        4,
  'Status Card':        4,
  // General — controls
  'Status':             4,
  'Switch':             4,
  'Set Value':          4,
  // General — gauges
  'Circular Gauge':     5,
  'Semi Circular Gauge':5,
  'Linear Gauge':       5,
  'Speed Gauge':        5,
  'Temperature Gauge':  5,
  // General — charts
  'Line Chart':         6,
  'Bar Chart':          6,
  'Area Chart':         6,
  'Pie Chart':          6,
  'Radar Chart':        6,
  'Doughnut Chart':     6,
  'Scatter Chart':      6,
  // General — tables
  'Timeseries Table':   6,
  // DT-special
  'dt-radial-gauge':      5,
  'dt-simulation-gauge':  5,
  'dt-temperature-grid':  5,
  'dt-temperature-trend': 6,
  'dt-metering-bars':     6,
  'dt-breaker-data':      7,
  'dt-vfd-status':        6,
  'dt-status-indicators': 5,
  'dt-voltage-table':     5,
  'dt-current-table':     5,
  'dt-general-info':      4,
};

export function getDefaultWidgetH(type) {
  return DEFAULT_WIDGET_H[type] ?? 5;
}

export function makeDefaultWidget(type, id) {
  const h = getDefaultWidgetH(type);
  return {
    id: id || `widget-${Date.now()}`,
    type,
    widgetName: type,
    props: {
      basic: {
        widgetName: type,
        fontSize: 14,
        fontType: 'Roboto',
        // No hardcoded colors — buildDTWidgetCardSx derives them from the active theme
        borderSize: 1,
        borderRadius: 4,
        scrollMode: 'fixed',
      },
      extended: {
        datapoints: [],
        tagprops: [],
      },
    },
    gridmeta: { x: 0, y: 0, w: 2, h },
  };
}
